// Author Eric
// Date 2023-11-29 13:03:04

class SithMesPrdWorkHourRecord {
constructor({
        id = null,
        userId = '',
        userName = '',
        prdPpOperationId = '',
        startTime = '',
        endTime = '',
        prdStopWorkTypeId = '',
        actualMstLocationId = '',
        actualMstLocationName = '',
        beforeUpdateMstLocationId = '',
        remark = '',
        sapRewriteStatus = '',
        sapRewriteMessage = ''}
= {}) {
    this.id = id;
    this.userId = userId;
    this.userName = userName;
    this.prdPpOperationId = prdPpOperationId;
    this.startTime = startTime;
    this.endTime = endTime;
    this.prdStopWorkTypeId = prdStopWorkTypeId;
    this.actualMstLocationId = actualMstLocationId;
    this.actualMstLocationName = actualMstLocationName;
    this.beforeUpdateMstLocationId = beforeUpdateMstLocationId;
    this.remark = remark;
    this.sapRewriteStatus = sapRewriteStatus;
    this.sapRewriteMessage = sapRewriteMessage;
}
}

function newEntity() {
return new SithMesPrdWorkHourRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'userName',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.userName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.orderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'prdPpOperationName',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.prdPpOperationName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'startTime',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.startTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'endTime',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.endTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'workHours',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.workHours',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'prdStopWorkTypeName',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.prdStopWorkTypeName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'actualMstLocationName',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.actualMstLocationName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sapRewriteStatus',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.sapRewriteStatus',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '回写成功' },
                            { value: '2', text: '回写失败' },
                            { value: '3', text: '跳过回写' },
                            { value: '4', text: '等待回写' }
            ]
                }
        },
        {
        key: 'beforeUpdateMstLocationName',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.beforeUpdateMstLocationName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'sapRewriteMessage',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.grid.sapRewriteMessage',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    userIdInFilter : [],
    userNameFilter : '',
    emAclDeptIdFilter : '',
    emAclDeptNameFilter : '',
    emAclDeptNodeCodeFilter : '',
    emAclDeptNodeCodeNameFilter : '',
    endTimeIsNullFilter : '',
    projectCodeFilter : '',
    orderCodeFilter : '',
    prdPpOperationIdFilter : '',
    prdPpOperationIdInFilter : [],
    prdPpOperationNameFilter : '',
    tsdItemNameFilter : '',
    startTimeRteFilter : '',
    startTimeLteFilter : '',
    endTimeRteFilter : '',
    endTimeLteFilter : '',
    endTimeRteQueryStartTimeFilter : '',
    startTimeLteQueryEndTimeFilter : '',
    prdStopWorkTypeIdFilter : '',
    actualMstLocationIdFilter : '',
    actualMstLocationIdInFilter : [],
    actualMstLocationNameFilter : '',
    beforeUpdateMstLocationIdFilter : '',
    beforeUpdateMstLocationNameFilter : '',
    sapRewriteStatusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'userNameFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.userName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'endTimeIsNullFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.endTimeIsNull',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.orderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prdPpOperationNameFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.prdPpOperationName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.startTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'startTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.startTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'endTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.endTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'endTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.endTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prdStopWorkTypeIdFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.prdStopWorkTypeId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdStopWorkType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'actualMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.actualMstLocationName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'beforeUpdateMstLocationNameFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.beforeUpdateMstLocationName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sapRewriteStatusFilter',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.filter.sapRewriteStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '回写成功' },
                { value: '2', text: '回写失败' },
                { value: '3', text: '跳过回写' },
                { value: '4', text: '等待回写' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'userName',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.entity.userName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"userId":"id"}'
                }
        },
        {
        key: 'prdPpOperationId',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.entity.prdPpOperationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'startTime',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.entity.startTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'endTime',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.entity.endTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prdStopWorkTypeId',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.entity.prdStopWorkTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdStopWorkType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'actualMstLocationName',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.entity.actualMstLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"actualMstLocationId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'sapRewriteStatus',
        label: 'label.sith.prd.sithMesPrdWorkHourRecord.entity.sapRewriteStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '回写成功' },
                { value: '2', text: '回写失败' },
                { value: '3', text: '跳过回写' },
                { value: '4', text: '等待回写' }
            ]
        }
        },
]

export {SithMesPrdWorkHourRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
